import {CreateControllerFn} from '@wix/yoshi-flow-editor'
import {createEventHandler} from '@wix/tpa-settings'
import {Reservation} from '@wix/ambassador-table-reservations-v1-reservation/types'

import {isTemplateView} from '../../utils/flowAPI'
import {SettingsEvents, SettingsEventsValues, TransactionNames} from '../../utils/constants'

import {initReservationConfirmationStorage, mockReservationConfirmationStorage} from './storage'

const createController: CreateControllerFn = async ({flowAPI, controllerConfig}) => {
  const publicData = controllerConfig.config.publicData.COMPONENT || {}
  const handler = createEventHandler<SettingsEventsValues>(publicData)
  return {
    async pageReady() {
      const pageLoadTransaction = flowAPI.panoramaClient.transaction(TransactionNames.pageLoad)
      pageLoadTransaction.start()

      const isEditor = flowAPI.environment.isEditor
      const isPreview = flowAPI.environment.isPreview
      const isTemplate = isTemplateView(flowAPI)

      handler.on(SettingsEvents.APPROVAL_TEXT_SETTINGS, (value) => {
        flowAPI.controllerConfig.setProps({approvalTextEditorState: value})
      })

      if (isEditor || isPreview || isTemplate) {
        const mockedStorage = await mockReservationConfirmationStorage(flowAPI)
        flowAPI.controllerConfig.setProps(mockedStorage)
      } else {
        let reservation: Reservation | undefined
        const storage = initReservationConfirmationStorage(flowAPI)
        flowAPI.controllerConfig.setProps(storage)

        if (storage.reservationId) {
          storage.getReservationLocations()
          reservation = await storage.getReservation(storage.reservationId)
        }

        if (storage.orderId) {
          await storage.getOrderDetails(storage.orderId)
        }

        if (reservation?.details?.experienceId) {
          await storage.getExperience(reservation.details.experienceId)
        }
      }

      pageLoadTransaction.finish()
    },
    updateConfig(_, config) {
      handler.notify(config.publicData.COMPONENT || {})
    },
  }
}

export default createController
